import { Box, Typography } from "@mui/material";
import { CampaignWritingMode } from "schemas/dashboard";

import StyledLargeButton from "components/Styled/Button/StyledLargeButton";

import styles from "./styles";

interface Props {
  mode: CampaignWritingMode;
  onChange: (mode: CampaignWritingMode) => void;
  brandCount: number;
  locked?: boolean;
  onUpgrade?: () => void;
}

export default function ModeChoice({
  mode,
  onChange,
  brandCount,
  locked = false,
  onUpgrade,
}: Props) {
  const aiSelected = mode === CampaignWritingMode.ai && !locked;
  return (
    <Box sx={styles.modeGrid}>
      <Box
        sx={styles.mode(aiSelected, locked)}
        onClick={() => !locked && onChange(CampaignWritingMode.ai)}
      >
        {locked ? (
          <Box sx={styles.modeCheck(false)}>
            <Box
              component="i"
              className="fa-solid fa-lock"
              sx={{ color: "#776B5D" }}
            />
          </Box>
        ) : (
          <Box sx={styles.modeCheck(aiSelected)}>
            {aiSelected && <Box component="i" className="fa-solid fa-check" />}
          </Box>
        )}
        <Box sx={styles.modeIcon(true)}>
          <Box component="i" className="fa-solid fa-sparkles" />
        </Box>
        <Typography sx={styles.modeHeading}>
          AI-personalize each pitch
          <Box component="span" sx={locked ? styles.badgePro : styles.badgeRec}>
            {locked ? "Pro" : "Recommended"}
          </Box>
        </Typography>
        <Typography sx={styles.modeBody}>
          Bento drafts a unique email per brand using their products, recent
          launches, and your profile. You review them all before anything sends.
        </Typography>
        {locked && onUpgrade && (
          <StyledLargeButton
            color="primary"
            styles={styles.modeUpgradeBtn}
            onClick={(e) => {
              e.stopPropagation();
              onUpgrade();
            }}
          >
            <Box
              component="i"
              className="fa-solid fa-lock"
              sx={{ mr: 0.75, fontSize: 13 }}
            />
            Upgrade to Pro to unlock
          </StyledLargeButton>
        )}
      </Box>

      <Box
        sx={styles.mode(mode === CampaignWritingMode.template, false)}
        onClick={() => onChange(CampaignWritingMode.template)}
      >
        <Box sx={styles.modeCheck(mode === CampaignWritingMode.template)}>
          {mode === CampaignWritingMode.template && (
            <Box component="i" className="fa-solid fa-check" />
          )}
        </Box>
        <Box sx={styles.modeIcon(false)}>
          <Box component="i" className="fa-regular fa-copy" />
        </Box>
        <Typography sx={styles.modeHeading}>
          Use one template for everyone
        </Typography>
        <Typography sx={styles.modeBody}>
          Pick a saved template with {"{Brand Name}"} and {"{First Name}"} merge
          fields. The same copy goes to all {brandCount} brands on the list.
        </Typography>
      </Box>
    </Box>
  );
}
